import Styles from './styles.module.css';
import '../salon/auth/login/tokens.css';
import React, { useEffect, useMemo, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import NoIndex from '../components/NoIndex';
import Salons from "./1.jobPostings/index";
import SchoolInitializer from './0.functions/getSchoolInfo';
import UsersInitializer from './0.functions/getUsersData';
import SchoolStudentSalon from './3.salon';
import StudentSwicth from './2.students/index';
import GuidancePage from './4.guidance/index';
// 公欠申請は schools/{id}.absence.web が true の学校にだけ出す
import AbsenceRequests from './5.absence/index';
import SchoolSearch from './9.items/1.search/index';
import { IoSearchOutline, IoSwapHorizontalOutline } from "react-icons/io5";
import { getFirestore, doc, getDoc } from 'firebase/firestore';


const NAV_PATH: Record<number, string> = {
  1: 'recruit',
  2: 'students',
  3: 'salon',
  4: 'guidance',
  5: 'absence',
};

const PATH_NAV: Record<string, number> = {
  recruit: 1,
  students: 2,
  salon: 3,
  guidance: 4,
  absence: 5,
};

const School: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  // 画面(navigation番号)はURL(/school/service/xxx)のパスから求める。
  // これによりリロード・URL共有・ブラウザバックのいずれでも、開いていた画面が保たれる。
  const currentSegment = location.pathname.split('/').pop() ?? '';
  const navigation = PATH_NAV[currentSegment] ?? 1;

  // Navigation/SchoolSearch等の既存コンポーネントは setNavigation(number) という
  // インターフェースを前提にしているため、内部でnavigate()に変換するラッパーを渡す。
  const setNavigation: React.Dispatch<React.SetStateAction<number>> = (value) => {
    const next = typeof value === 'function' ? (value as (prev: number) => number)(navigation) : value;
    navigate(`/school/service/${NAV_PATH[next] ?? 'recruit'}`);
  };

  const [ isMac, setIsMac ] = useState<boolean>(false);
  
  const [ contract, setContract ] = useState<boolean>(false);
  const [ searchToggle, setSearchToggle ] = useState<boolean>(false);

  const [ schoolId, setSchoolId ] = useState<string>("");
  const [ schoolName, setSchoolName ] = useState<string>("");

  // さんぽう(ガイダンス事業者)が利用するアカウント。求人情報/学生の進捗情報/サロン分析は見せず、
  // ガイダンス回答状況のみを表示する。
  const isSanpouSchool = schoolId === "ZuxAJPg4JIilqIhvJRdB";

  // ガイダンス回答状況タブは2026-10-15に一旦全校非表示にした(開催していないため)。
  // 個別に許可した学校だけ明示的に表示する: TEST専門学校(デモ用)・ユニバーサル美容専門学校(2026-10-26)。
  // info/guidance に基準設定があれば hasGuidance は true になるが、タブ表示はこのリストで絞る。
  const GUIDANCE_VISIBLE_SCHOOL_IDS = ["D1CPXkL7Zg2iTwxdiBfh", "byOKvy9ixN60ueUw5EbG"];
  const isGuidanceVisibleSchool = GUIDANCE_VISIBLE_SCHOOL_IDS.includes(schoolId);

  const [ schoolInfo, setSchoolInfo ] = useState<SchoolInfo | null>(null);

  const [ allUsers, setAllUsers ] = useState<any[]>([]);
  const [ filteredUsers, setFilteredUsers ] = useState<any[]>([]);
  // 学生のデータを一度でも受け取ったか(それまでは各表に「読み込み中」を出す)
  const [ usersLoaded, setUsersLoaded ] = useState<boolean>(false);

  const [ hashTags, setHashTags ] = useState<string[]>([]);
  const [ hasGuidance, setHasGuidance ] = useState<boolean>(false);
  const [ guidanceClasses, setGuidanceClasses ] = useState<string[]>([]);
  const [ guidanceClass, setGuidanceClass ] = useState<string>('');

  const db = getFirestore();

  // 公欠申請のタブを出すか(schools/{id}.absence.web)。学生アプリから申請を受け付けるのは absence.app。
  // null は読み込み中(/school/service/absence を開いたまま再読み込みしたとき、読み込み前にガイダンスへ飛ばさないため)
  const [ absenceWeb, setAbsenceWeb ] = useState<boolean | null>(null);
  useEffect(() => {
    if (!schoolId) return;
    getDoc(doc(db, 'schools', schoolId))
      .then((snap) => setAbsenceWeb(snap.data()?.absence?.web === true))
      .catch((e) => console.error(e));
  }, [schoolId, db]);

  useEffect(() => {
    if (!schoolName) return;
    const checkGuidance = async () => {
      const snap = await getDoc(doc(db, 'info', 'guidance'));
      const criteria = snap.data()?.[schoolName];
      setHasGuidance(snap.exists() && schoolName in (snap.data() ?? {}));
      setGuidanceClasses(criteria?.class ?? []);
    };
    checkGuidance();
  }, [schoolName]);

  const tabs: { label: string; num: number }[] = [
    { label: "求人情報", num: 1 },
    ...(contract ? [{ label: "学生の進捗情報", num: 2 }, { label: "サロン分析", num: 3 }] : []),
    // ガイダンス回答状況は一旦非表示(2026-10-15、今開催していないため)。
    // 個別に許可した学校だけ先行表示する(GUIDANCE_VISIBLE_SCHOOL_IDS参照)
    ...(hasGuidance && isGuidanceVisibleSchool ? [{ label: "ガイダンス回答状況", num: 4 }] : []),
    // 公欠申請は契約の有無に関係なく、自校の学生がアプリから出したものを見られるようにする。
    // schools/{id}.absence.web が true の学校だけに表示(2026-10-26、TEST専門学校・コーセー美容専門学校で有効化)
    ...(absenceWeb ? [{ label: "公欠申請", num: 5 }] : []),
  ];

  useEffect(() => {
    const filtered = allUsers.filter((user) =>
      hashTags.every((tag) => user.hashTags.includes(tag))
    );

    setFilteredUsers(filtered);
  }, [hashTags, allUsers]);

  const allClasses = useMemo<string[]>(() => {
    if (!schoolInfo?.departments) return [];

    return getClassesFromDepartments(schoolInfo.departments);
  }, [schoolInfo?.departments]);

  function getClassesFromDepartments(
    departments: SchoolInfo["departments"]
  ): string[] {
    return Array.from(
      new Set(Object.values(departments).flatMap(d => Object.values(d?.grades ?? {}).flatMap(g => g?.classes ?? [])))
    );
  }

  return (
    <>
    <NoIndex title="学校管理画面 | memorii works" />
    <div className={Styles.page}>
    {/* データ取得 */}
    <SchoolInitializer
      onResolved={({ schoolId, schoolName, contract, schoolInfo }) => {
        setSchoolId(schoolId);
        setSchoolName(schoolName);
        setContract(contract);
        setSchoolInfo(schoolInfo);
      }}
    />

    <UsersInitializer
      schoolName={schoolName}
      onResolved={({ allUsers, filteredUsers }) => {
        setAllUsers(allUsers);
        setFilteredUsers(filteredUsers);
        setUsersLoaded(true);
      }}
    />

    <div className={Styles.header}>
      {isSanpouSchool ? (
        <h4>ガイダンス回答状況</h4>
      ) : (
        <>
          <div className={Styles.tabs}>
            {tabs.map((t) => (
              <button
                key={t.num}
                type="button"
                data-testid={`school-nav-item-${t.num}`}
                className={navigation === t.num ? `${Styles.tab} ${Styles.tab_active}` : Styles.tab}
                onClick={() => setNavigation(t.num)}>
                {t.label}
              </button>
            ))}
          </div>
          {(navigation === 1 || navigation === 2) && (
            <button className={Styles.search_btn} onClick={() => setSearchToggle(prev => !prev)}>
              {navigation === 1 ? (
                <>
                  <IoSearchOutline className={Styles.search_btn_icon} />
                  検索
                </>
              ) : (
                <>
                  <IoSwapHorizontalOutline className={Styles.search_btn_icon} />
                  表示切替
                </>
              )}
            </button>
          )}
        </>
      )}
    </div>

    {(navigation === 2 || navigation === 3 || navigation === 4 || navigation === 5) && (
      <SchoolSearch
        navigation={navigation}
        setHashTags={setHashTags}
        schoolInfo={schoolInfo}
        guidanceClasses={guidanceClasses}
        setGuidanceClass={setGuidanceClass} />
    )}

    <div style={isMac ? {}  : { width: "20px calc((100% - 1200px) / 2) 50px calc((100% - 1200px) / 2)" }}>
      <Routes>
        <Route index element={<Navigate to={isSanpouSchool ? "guidance" : "recruit"} replace />} />

        <Route path="recruit" element={isSanpouSchool ? <Navigate to="/school/service/guidance" replace /> : (
          <Salons
            searchToggle={searchToggle}
            setSearchToggle={setSearchToggle}
            schoolId={schoolId}
            schoolName={schoolName} />
        )} />

        <Route path="students" element={isSanpouSchool ? <Navigate to="/school/service/guidance" replace /> : (
          <StudentSwicth
            schoolId={schoolId}
            searchToggle={searchToggle}
            allClasses={allClasses}
            hashTags={hashTags}
            filteredUsers={filteredUsers}
            usersLoaded={usersLoaded}
            schoolName={schoolName} />
        )} />

        <Route path="salon" element={isSanpouSchool ? <Navigate to="/school/service/guidance" replace /> : (
          <SchoolStudentSalon
            hashTags={hashTags}
            schoolId={schoolId}
            usersLoaded={usersLoaded}
            filteredUsers={filteredUsers} />
        )} />

        {/* ガイダンス回答状況は一旦非表示(タブの tabs を参照)。isSanpouSchool・許可した学校(デモ等)はそのまま開ける */}
        <Route path="guidance" element={(isSanpouSchool || (hasGuidance && isGuidanceVisibleSchool)) ? <GuidancePage selectedClass={guidanceClass} /> : <Navigate to="/school/service/recruit" replace />} />

        {/* 公欠申請は schools/{id}.absence.web が true の学校だけに表示(タブの tabs を参照) */}
        <Route path="absence" element={absenceWeb === null ? null : (isSanpouSchool || !absenceWeb) ? <Navigate to="/school/service/guidance" replace /> : (
          <AbsenceRequests schoolId={schoolId} allUsers={allUsers} hashTags={hashTags} filteredUsers={filteredUsers} />
        )} />
      </Routes>
    </div>
    </div>
    </>
  );
}

export default School;

export interface SchoolInfo {
  id: string;
  departments: Record<string, SchoolDepartment>;
}

export interface SchoolDepartment {
  grades: Record<string, SchoolGrade>;
}

export interface SchoolGrade {
  classes: SchoolClass[];
}

export type SchoolClass = string;
